import { render, staticRenderFns } from "./SettingVendorDisplay.vue?vue&type=template&id=c4c267c2"
import script from "./SettingVendorDisplay.vue?vue&type=script&lang=js"
export * from "./SettingVendorDisplay.vue?vue&type=script&lang=js"
import style0 from "./SettingVendorDisplay.vue?vue&type=style&index=0&id=c4c267c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports